import React, { useState } from 'react';

import CustomTh from '../shared/table/CustomTh';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import UnsoldQueueItem from './UnsoldQueueItem';
import useFilter from '../../utilities/useFilter';
import SelectList from '../shared/inputs/SelectList';
import postData from '../../utilities/postData';
import Button from 'react-bootstrap/Button';
import PrintConfirmModal from './PrintConfirmModal';
import PagedListControl from '../shared/lists/PagedListControl';

const UnsoldQueue = () => {
    const { items, setData, filter, setFilter, submitFilter, pageInfo } = useFilter('/api/dashboard/unsoldFollowUps', { days: 90, pageSize: 0 }, true);

    const [showConfirm, setShowConfirm] = useState(false);

    const changeFilter = (e) => {
        setFilter(e);
        submitFilter();
    }

    function editItem(item) {
        const currentData = JSON.parse(JSON.stringify(items));
        const idx = currentData.findIndex(x => x.proposalId === item.proposalId);
        currentData[idx] = item;
        setData(currentData);
    }

    function selectAll({ target: { name, checked } }) {
        const currentData = JSON.parse(JSON.stringify(items));
        currentData.forEach((item) => {
            item[name] = checked;
        });
        setData(currentData);
    }

    const tableHead = (
        <thead className="table-index-head">
            <tr>
                <CustomTh content="Customer" />
                <CustomTh width="85px" content="Date" />
                <CustomTh width="100px" className="text-center" content="7 Day" />
                <CustomTh width="100px" className="text-center" content="30 Day" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item) =>
        <UnsoldQueueItem
            editItem={editItem}
            item={item}
            key={item.proposalId}
        />);

    return (
        <div className="dashboard-container">
            <Col>
                <Form.Row className="m-0">
                    <Col xs="auto">
                        <div className="dashboard-follow-ups-title">Unsold Queue</div>
                    </Col>
                    <Col xs="auto" lg>
                        <SelectList style={{ maxWidth: '110px' }} name="days" value={filter.days} onChange={changeFilter} >
                            <option value="90">90 days</option>
                            <option value="60">60 days</option>
                            <option value="30">30 days</option>
                        </SelectList>
                    </Col>
                    <Col className="d-lg-none"></Col>
                    <Col className="d-flex align-items-center justify-content-end" style={{ maxWidth: '100px' }}>
                        <label className="custom-control custom-checkbox d-inline-flex mb-0">
                            <input type="checkbox" className="custom-control-input" name="sendDay7FollowUp"
                                onChange={selectAll}
                            />
                            <span className="custom-control-label small" style={{ paddingTop: '.1em' }}>Select All</span>
                        </label>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center" style={{ maxWidth: '100px' }}>
                        <label className="custom-control custom-checkbox d-inline-flex mb-0">
                            <input type="checkbox" className="custom-control-input" name="sendDay30FollowUp"
                                onChange={selectAll}
                            />
                            <span className="custom-control-label small" style={{ paddingTop: '.1em' }}>Select All</span>
                        </label>
                    </Col>
                </Form.Row>
                <Row>
                    <Col>
                        <div className="fixed-table-head dashboard-follow-ups">
                            <Table striped size="sm">
                                {tableHead}
                                <tbody>
                                    {listItems}
                                </tbody>
                            </Table>
                            {(pageInfo.isFirstPage && pageInfo.isLastPage) ||
                                <PagedListControl {...pageInfo} />
                            }
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-end p-2">
                    <Col xs="auto">
                        <Button variant='info'
                            onClick={() => postData('/Followups/GetFollowUpLetters', items, () => setShowConfirm(true), null, false)}
                        >Generate Follow-Ups</Button>
                    </Col>
                </Row>
            </Col>
            <PrintConfirmModal
                items={items}
                show={showConfirm}
                commitUrl={'/Followups/CommitFollowUpLetters'}
                setShow={setShowConfirm}
                resetParent={submitFilter}
            />
        </div>
    );
}

export default UnsoldQueue;